import type { CnstrcContentSlot } from '@/js/services/cnstrc/types'
import type { IReflektionProcessedProduct } from '@/js/services/rfk/types'

export type GridItem = {
  key: string,
  content?: CnstrcContentSlot,
  product?: IReflektionProcessedProduct,
  // Position among products only, so card tracking and preload hints stay 0-based over
  // the real result set no matter how many content slots sit in the grid.
  index: number,
}

/**
 * Interleaves `placement:grid` content rules into the product grid at their
 * `results_position` (1-based). Slots are inserted in ascending order so each position
 * is the slot's final index — what a merchandiser counting cards expects — and a
 * position past the end of the results lands at the end rather than being dropped.
 */
export function buildGridItems(
  products: IReflektionProcessedProduct[],
  contentSlots: CnstrcContentSlot[]
): GridItem[] {
  const items: GridItem[] = products.map((product, index) => ({
    key: `p-${product.productId}`, product, index,
  }))

  const inGrid = contentSlots
    .filter(slot => slot.placement === 'grid')
    .sort((a, b) => a.resultsPosition - b.resultsPosition)

  for (const slot of inGrid) {
    const at = Math.min(Math.max(slot.resultsPosition - 1, 0), items.length)
    items.splice(at, 0, { key: `c-${slot.id}`, content: slot, index: at })
  }

  return items
}
